'use client';

import { Card, CardContent } from '@repo/ui';
import { Loader2 } from 'lucide-react';
import type * as React from 'react';

export function LinkingCard(): React.ReactNode {
  return (
    <Card className="w-full max-w-sm">
      <CardContent className="flex flex-col items-center gap-3 pt-6">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">Connecting your account...</p>
      </CardContent>
    </Card>
  );
}
